
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/food-menu",
      function () {
        return require("private-next-pages/food-menu/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/food-menu"])
      });
    }
  